// extracted by mini-css-extract-plugin
module.exports = {"container":"PaymentMode_container__2tg2K","selectAll":"PaymentMode_selectAll__1VXH6"};